module.exports = __webpack_public_path__ + "img/Healthy HSA Investor Infographic.ee399e11.png";